import React from 'react';
import ChatWindow from './chat/ChatWindow';
import { useModels } from '../contexts/ModelContext';

const DualChatLayout = ({
  selectedChat,
  primaryMessages,
  secondaryMessages,
  primaryModel,
  secondaryModel,
  onQuestionClick,
  onArtifactOpen,
  reasoningStream,
  onEditMessage,
  onMessageSent,
  updateChatTitle,
  hasSubscription,
  messageLimit,
  editingMessage,
  onCancelEdit,
  applyEditAndTruncate
}) => {
  const { getModelByModelString } = useModels();
  const primaryModelDetails = getModelByModelString(primaryModel);
  const secondaryModelDetails = getModelByModelString(secondaryModel);

  return (
    <div className="flex h-full relative">
      {/* Left Chat Panel */}
      <div className="flex flex-col relative w-1/2">
        {/* Model Header */}
        <div className="flex items-center justify-center py-2 px-4 border-b theme-border z-10">
          <div className="flex items-center gap-2">
            <span 
              className="px-3 py-1 text-sm rounded-full text-white font-medium"
              style={{ backgroundColor: primaryModelDetails?.color || '#808080' }}
            >
              {primaryModelDetails?.name || 'Primary Model'}
            </span>
          </div>
        </div>
        
        {/* Chat Window */}
        <div className="flex-1 overflow-hidden">
          <ChatWindow
            selectedChat={selectedChat}
            messages={primaryMessages || []}
            selectedModel={primaryModel}
            reasoningStream={reasoningStream}
            onQuestionClick={onQuestionClick}
            onArtifactOpen={onArtifactOpen}
            onEditMessage={onEditMessage}
            onMessageSent={onMessageSent}
            updateChatTitle={updateChatTitle}
            hasSubscription={hasSubscription}
            messageLimit={messageLimit}
            editingMessage={editingMessage}
            onCancelEdit={onCancelEdit}
            applyEditAndTruncate={applyEditAndTruncate}
          />
        </div>
      </div>

      {/* Separator */}
      <div className="w-px border-l theme-border"></div>

      {/* Right Chat Panel */}
      <div className="flex flex-col relative w-1/2">
        {/* Model Header */}
        <div className="flex items-center justify-center py-2 px-4 border-b theme-border z-10">
          <div className="flex items-center gap-2">
            <span 
              className="px-3 py-1 text-sm rounded-full text-white font-medium"
              style={{ backgroundColor: secondaryModelDetails?.color || '#808080' }}
            >
              {secondaryModelDetails?.name || 'Secondary Model'}
            </span>
          </div>
        </div>
        
        {/* Chat Window */}
        <div className="flex-1 overflow-hidden">
          <ChatWindow
            selectedChat={selectedChat}
            messages={secondaryMessages || []}
            selectedModel={secondaryModel}
            reasoningStream={reasoningStream}
            onQuestionClick={onQuestionClick}
            onArtifactOpen={onArtifactOpen}
            onEditMessage={onEditMessage}
            onMessageSent={onMessageSent}
            updateChatTitle={updateChatTitle}
            hasSubscription={hasSubscription}
            messageLimit={messageLimit}
            editingMessage={editingMessage}
            onCancelEdit={onCancelEdit}
            applyEditAndTruncate={applyEditAndTruncate}
          />
        </div>
      </div>
    </div>
  );
};

export default DualChatLayout;
